export const settings = {
  default: {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    allowTouchMove: true,
    watchOverflow: true,
  },

  games: {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    freeMode:true,
    breakpoints: {
      // 960: {
      //   slidesPerView: 4,
      // },
      // 1200: {
      //   slidesPerView: 4,
      // },
      // 1600: {
      //   slidesPerView: 4,
      // }
    }
  },

  authorTabs:{
    slidesPerView: "auto",
    spaceBetween: 8,
    watchOverflow: true,
    freeMode:true,
  },

  onMethodsExample: {
    onInit: function () {
      console.log("функция с новым onInit");
    },
    onSlideChange: function (swiper, readIndex, arrayLength) {
      console.log("Получить данные", swiper, readIndex, arrayLength);
    }
  },

  podcastsSetting: {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    // centeredSlides:true,
    centeredSlidesBounds: true,
    grabCursor: true,
    // navigation: {
    //   prevEl: ".podcasts__nav-button_prev",
    //   nextEl: ".podcasts__nav-button_next",
    // },
    pagination: {
      type: 'bullets',
      clickable: true,
    },

    breakpoints: {
      960: {
        spaceBetween: 24
      },
      1200: {
        spaceBetween: 24
      },
      1600: {
        spaceBetween: 24,
      }
    }
  },

  originalSetting: {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    centeredSlidesBounds: true,
    grabCursor: true,

    breakpoints: {
      960: {
        spaceBetween: 24
      },
      1200: {
        spaceBetween: 24
      },
      1600: {
        spaceBetween: 24,
      }
    }
  },
  narrativesSetting: {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    grabCursor: true,
    freeMode: true,
    breakpoints: {
      960: {
        spaceBetween: 24,
      },
      1200: {
        spaceBetween: 32,
      },
      1600: {
        spaceBetween: 32,
      }
    },

    navigation: {
      prevEl: ".narratives__nav-button_prev",
      nextEl: ".narratives__nav-button_next",
    }
  },

  narrativesModalSettings: {
    autoplay: {
      delay: 15_000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    watchSlidesProgress: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 16,
    watchOverflow: true,
    pagination: {
      el: ".narratives-modal__pagination",
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class="' + className + '"> <div class="swiper-pagination-progress"></div> </div>';
      }
    },
    navigation: {
      prevEl: ".narratives-modal__nav-button_prev",
      nextEl: ".narratives-modal__nav-button_next",
    },
  },

  series: {
    slidesPerView: "auto",
    centeredSlides: false,
    loop: false,
    spaceBetween: 8,
    allowTouchMove: true,
    watchOverflow: true,
    freeMode:true,
    // navigation: {
    //   prevEl: '.project__nav_prev',
    //   nextEl: '.project__nav_next',
    // },
  },

  customPaginationExample: {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class=\"' + className + '\"><p>' + index + '</p></div>';
      }
    }
  }

}
